module.exports = __webpack_public_path__ + "static/img/standardPic4.831868e2.png";